<template>
    <v-card flat>
        <v-card-title v-show="ShowHeader"><span style="font-weight:bold;">Airlines</span></v-card-title>
            <v-card-text v-if="Loading==true">
                <div class="text-xs-center">
                <v-progress-circular
                
                indeterminate
                color="primary"
                ></v-progress-circular>
                </div>
            </v-card-text>


        <v-list v-if="Loading==false" class="">
            <v-list-tile class="less-margin-selall less-margin">
                <v-list-tile-action class="pa-0">
                    <v-checkbox v-model="allSelected" @change="selectAll()"></v-checkbox>
                </v-list-tile-action>   
                <v-list-tile-content>
                    <v-list-tile-title>
                        Select all
                    </v-list-tile-title>
                </v-list-tile-content>             
            </v-list-tile>       
            <v-divider></v-divider>     
            <v-list-tile v-for="(airline,index) in Airlines" :key="index" class="less-margin">
                <v-list-tile-action class="pa-0">
                    <v-checkbox v-model="airline.selected" @change="getSelectedAirlines()"></v-checkbox>
                </v-list-tile-action>   
                <v-list-tile-content>
                    <v-list-tile-title>
                        {{airline.code + '-' + airline.name}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                        {{helper.numberFormat.formatPrice(airline.minPrice) +'-'+helper.numberFormat.formatPrice(airline.maxPrice)}}
                    </v-list-tile-sub-title>
                </v-list-tile-content>             
            </v-list-tile>
        </v-list>
    </v-card>
</template>

<script>
import helper from '../helper'
export default {
    props:[
        'ShowHeader','Airlines', 'Loading'
    ],
    data(){
        return {
            mockedAirlines:[
                {code:"H1", name:"Hahn Air Systems",minPrice:"6,150.00",maxPrice:"6,370.00"},
                {code:"PG", name:"Bangkok Airways",minPrice:"6,330.00",maxPrice:"6,615.00"},                                                     
                {code:"PG", name:"Bangkok Airways",minPrice:"6,330.00",maxPrice:"6,615.00"},                                                                                                                              
                {code:"PG", name:"Bangkok Airways",minPrice:"6,330.00",maxPrice:"6,615.00"},                                                                                                                              
            ],
            loading:false,
            helper:helper,
            allSelected:true
        }
    },
    watch:{
        Loading:{
            handler:{
                handler:function(val,oldVal){
                    if(val!=oldVal&&val==false) {
                        this.setSelectAllInd();
                        
                    }
                }
            }
      }
    },
    methods:{
        selectAll(){
            this.Airlines.forEach((item) => {
                item.selected = this.allSelected;
            });
            this.getSelectedAirlines();
        },
        getSelectedAirlines(){
            /*
            var filtered = this.Airlines.filter(a=>{
                return a.selected==true;
            })*/

            var lstAirlines = new this.$linq(this.Airlines);
            var filtered = lstAirlines.where(a=>{
                return a.selected == true;
            }).select(a=>{
                return a.code;
                }
            ).toArray();
            this.$emit('SelectedAirlines',filtered);
        },
        setSelectAllInd(){
            this.allSelected=true;
        }
    }    
}
</script>

<style>
.less-margin-selall>div{
    height: 30px;
}
.less-margin>div>div{
    min-width: 30px;
}
</style>
